
import { defineComponent, shallowRef, onBeforeUnmount, onMounted } from 'vue'
import swipe from 'essential/dom/swipe'

export default defineComponent({
  name: 'TouchableAlert',
  emits: ['close'],
  props: {
    autoClose: Boolean,
    zIndex: {
      type: [Number, String],
      default: 'unset',
    },
    closeTime: Number,
    clickDisable: Boolean,
  },
  setup (props, ctx) {
    const alertDom = shallowRef()
    const threshold = 20 // 上拉阈值
    let timer = 0

    onMounted(() => {
      resetTimer()
      if (alertDom.value) {
        swipe(alertDom.value, {
          direction: 'vertical',
          range: [-200, 20],
          resistanceRatio: 0.85,
          onSwiped ({ delta: [, deltaY] }, long, release) {
            if (deltaY < -threshold) {
              ctx.emit('close')
              clearTimeout(timer)
            } else {
              alertDom.value.style.transform = 'translate3d(0px, 0px, 0px)'
              resetTimer()
            }
            release()
          },
          onWillSwipe () {
            !props.clickDisable && clearTimeout(timer)
          },
        })
      }
    })

    onBeforeUnmount(() => {
      clearTimeout(timer)
    })

    const resetTimer = () => {
      if (props.autoClose || props.autoClose === undefined) {
        timer = window.setTimeout(() => ctx.emit('close'), props.closeTime ?? 1000 * 3)
      }
    }

    return {
      alertDom,
    }
  },
})
